import { BannerVariant } from "./types/banner-variant";

export function Banner({
  variant,
  title,
  message,
}: {
  variant: BannerVariant;
  title: string;
  message: string;
}) {
  if (variant === "none") return null;

  const base = "border px-4 py-3 rounded relative";

  const styles: Record<Exclude<BannerVariant, "none">, string> = {
    success: "bg-green-100 border-green-400 text-green-800",
    warning: "bg-yellow-100 border-yellow-400 text-yellow-800",
    error: "bg-red-100 border-red-400 text-red-800",
  };

  return (
    <div className={`${base} ${styles[variant]}`} role="alert">
      <strong className="font-bold text-sm block">{title}</strong>
      <span className="text-sm whitespace-pre-line">{message}</span>
    </div>
  );
}
